const styles = {
    fourColumnLayout: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: "20px",
    },
};

export default styles;
